import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { id: "main-content" }
const _hoisted_4 = { class: "article-info" }
const _hoisted_5 = { class: "entry-title" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GuoCangHeader = _resolveComponent("GuoCangHeader")!
  const _component_GuoCangFooter = _resolveComponent("GuoCangFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_GuoCangHeader, { msg: "Welcome to Your Vue.js + TypeScript App" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("article", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.article.title), 1),
          _createElementVNode("div", {
            innerHTML: _ctx.article.content,
            class: "content"
          }, null, 8, _hoisted_6)
        ]),
        _hoisted_7,
        _createVNode(_component_GuoCangFooter)
      ])
    ])
  ]))
}